import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchFormById = async (formId?: number) => {
	if (!formId) return Promise.reject("No id");

	const response = await cmsClient.get<IObservationForm>(
		`/observations/forms/${formId}/`
	);

	return response.data;
};

interface Options {
	enabled?: boolean;
}

const usePublishedForm = (
	formId?: number,
	options: Options = { enabled: true }
) => {
	const query = useQuery(
		["observationForm", formId],
		() => fetchFormById(formId),
		options
	);

	return query;
};

export default usePublishedForm;
